import jMoment from "moment-jalaali";
import React, { useState } from "react";
import JalaliUtils from "@date-io/jalaali";
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {useInput} from "react-admin";

jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

export function PersianDateExpirationDatePicker(props) {
  const {
    input: {name, onChange, ...rest},
  } = useInput(props);
  const [expirationDate, setExpirationDate] = useState(props.record.expirationDate || null);
  function expirationDateChange(e){
    setExpirationDate(e._d.setHours(0,0));
    onChange(e);
  }
  return (
    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
      <DatePicker
        label={props.label || ""}
        okLabel="تأیید"
        cancelLabel="لغو"
        clearLabel="پاک کردن"
        labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD") : "")}
        value={expirationDate}
        onChange={(e) => {
          expirationDateChange(e);
        }}
        inputVariant="filled"
      />
    </MuiPickersUtilsProvider>
  );
}
